import $ from 'jquery';
import moment from 'moment';

export default class Vacancy {
	constructor() {
		this.selectors = {
			el: '.js-vacancy',
			form: {
				wrapper: '.js-form',
				submit: '.js-form-submit',
				el: '.js-form-main',
				status: '.js-form-status',
				dateField: '.js-input-date',
				uploadField: '.js-upload'
			}
		};

		this.classes = {
			form: {
				status: 'form_state_status',
				success: 'form_state_success',
				error: 'form_state_error'
			},
			field: {
				error: 'field__input_state_error'
			},
			upload: {
				error: 'upload_state_error',
				success: 'upload_state_success'
			}
		};

		this.$el = $(this.selectors.el);
		this.$form = this.$el.find(this.selectors.form.el);
		this.$formWrap = this.$el.find(this.selectors.form.wrapper);
	}

	setErrorState = (field, error) => {
		field.addClass(this.classes.field.error);
		field.next().text(error);
	};

	checkDate = val => {
		const year = val.slice(-4);
		const month = Number(val.slice(3, 5));
		const day = val.slice(0, 2);
		const date = new Date(`${year}, ${month - 1}, ${day}`);
		return (date != 'Invalid Date' &&  moment(new Date(), 'DD/MM/YYYY').diff(moment(val, 'DD/MM/YYYY'), 'years') >= 18); //eslint-disable-line
	};

	onSubmit = e => {
		const $target = $(e.target);
		const $dateField = $target.find(this.selectors.form.dateField).find('input');
		const $uploadField = $target.find(this.selectors.form.uploadField);
		const $dateVal = $dateField.val();

		$uploadField.find('input').trigger('change');

		if ($dateVal && !this.checkDate($dateVal)) {
			this.setErrorState($dateField, 'Укажите корректную дату');
			e.preventDefault();

			return false;
		}

		if (!$uploadField.hasClass(this.classes.upload.success)) {
			e.preventDefault();

			return false;
		}

		return true;
	};

	setStatus(status, type) {
		const $status = this.$form.find(this.selectors.form.status);
		const stateClass = type === 'success' ? this.classes.form.success : this.classes.form.error;
		this.$formWrap.addClass(this.classes.form.status);
		this.$formWrap.addClass(stateClass);
		$status.text(status);
	}

	render() {
		if (this.$el.length) {
			this.$form.on('submit', this.onSubmit);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/vacancy/index.js
 **/